/**
 * FreeCell house rules.
 *
 * FreeCell has less genuine rule variation than either of the other two games.
 * Every card is face up from the deal, so there is no stock to make punishing
 * and no hidden information to argue over — what is left is the number of
 * cells, which is the entire difficulty curve, and one convenience that
 * computer versions invented and the cardboard game never had.
 */
export const TABLEAU_COLUMNS = 8;
/**
 * The cells are bounded on both sides. Zero cells makes almost every deal
 * unwinnable, and past six the game stops being FreeCell — it is a solitaire
 * with a spare hand.
 */
export const MIN_FREE_CELLS = 1;
export const MAX_FREE_CELLS = 6;
/** FreeCell is played alone. Stated so the lobby has something to read. */
export const MIN_PLAYERS = 1;
export const MAX_PLAYERS = 1;
const BASE = {
    freeCells: 4,
    supermoves: true,
    allowFoundationToTableau: true,
};
export const RULE_PRESETS = [
    {
        id: 'standard',
        name: 'Four cells',
        description: 'The version everyone knows. Nothing is hidden and almost every deal can be solved — losing is on you, not the shuffle.',
        rules: { ...BASE },
    },
    {
        id: 'tight',
        name: 'Two cells',
        description: 'The same deal with half the room to think. Long runs stop moving and the eight columns start to matter enormously.',
        rules: { ...BASE, freeCells: 2 },
    },
    {
        id: 'purist',
        name: 'By hand',
        description: 'Four cells, but sequences move one card at a time, exactly as they would on a table. Every supermove has to be played out.',
        rules: { ...BASE, supermoves: false },
    },
];
/** The set a fresh game starts with. */
export const DEFAULT_RULES = RULE_PRESETS[0].rules;
const BOOLEAN_KEYS = [
    'supermoves',
    'allowFoundationToTableau',
];
/**
 * Coerces untrusted input into a valid ruleset. Mirrors `sanitiseRules` on the
 * Switch and Solitaire sides: anything unrecognised falls back to the default
 * rather than throwing, so a stale client can never wedge a game.
 */
export function sanitiseRules(input) {
    const raw = (input ?? {});
    const rules = { ...DEFAULT_RULES };
    for (const key of BOOLEAN_KEYS) {
        if (typeof raw[key] === 'boolean')
            rules[key] = raw[key];
    }
    if (typeof raw.freeCells === 'number' && Number.isFinite(raw.freeCells)) {
        rules.freeCells = Math.min(MAX_FREE_CELLS, Math.max(MIN_FREE_CELLS, Math.round(raw.freeCells)));
    }
    return rules;
}
//# sourceMappingURL=rules.js.map